module.exports = __webpack_public_path__ + "static/img/itemBg.f501571.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/depositDetail/itemBg.png
// module id = CfY/
// module chunks = 0